import { utilTick } from "./utilTick";
var UtilMemoryUsage = /** @class */ (function () {
    function UtilMemoryUsage() {
        var _this = this;
        this.memoryUsageTrackingFreq = 5000;
        this.accumulatedMemoryUsage = 0;
        this.memoryUsage = 0;
        this.minMemoryUsage = 0;
        this.maxMemoryUsage = 0;
        this.memoryUsageCounter = 0;
        this.getMemoryUsage = function () { return _this.memoryUsage; };
        this.getMaxMemoryUsage = function () { return _this.maxMemoryUsage; };
        this.getMinMemoryUsage = function () { return _this.minMemoryUsage; };
        this.getAvgMemoryUsage = function () {
            return Math.floor(_this.accumulatedMemoryUsage / _this.memoryUsageCounter) || 0;
        };
        this.startMemoryUsageTracking = function () {
            var performanceData = window.performance;
            if (performanceData && performanceData.memory) {
                _this.memoryUsageCounter++;
                _this.setMemoryUsage(performanceData.memory.usedJSHeapSize);
            }
            else {
                _this.stopMemoryUsageTracking();
            }
        };
        this.stopMemoryUsageTracking = function () {
            _this.intervalSub$.unsubscribe();
        };
        this.setMemoryUsage = function (memoryUsage) {
            _this.memoryUsage = memoryUsage;
            _this.accumulatedMemoryUsage += memoryUsage;
            _this.maxMemoryUsage = Math.max(_this.maxMemoryUsage, memoryUsage);
            _this.minMemoryUsage = Math.min(_this.minMemoryUsage, memoryUsage);
        };
        this.intervalSub$ = utilTick
            .getInterval$(this.memoryUsageTrackingFreq)
            .subscribe(this.startMemoryUsageTracking);
    }
    return UtilMemoryUsage;
}());
export var utilMemoryUsage = new UtilMemoryUsage();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilMemoryUsage.ts
// module id = 1699
// module chunks = 3